/*jshint browserify: true */
'use strict';

/**
 * @name InteractionMode
 *
 * The PDF editor, at any given time, will have a single interaction mode selected.
 * E.g. selection mode, add text mode, etc.
 * This object is the *base* object for other interaction modes to inherit from.
 *
 * @param {Array} pdfElements - Array of PDFedit.elements.PdfElement
 * @param {Array} selectedPdfElements - Array of PDFedit.elements.PdfElement
 * @param {Array} pages - Array of PDFedit.document.Page
 */
var InteractionMode = (function InteractionModeClosure() {
    function InteractionMode(pdfElements, selectedPdfElements, pages) {
        this._addPdfElementCallbacks = [];
        this._cursorChangedCallbacks = [];
        this.pdfElements = pdfElements;
        this.selectedPdfElements = selectedPdfElements;
        this.pages = pages;

        var cursor = 'auto';
        Object.defineProperty(this, 'cursor', {
            get: function () { return cursor; },
            set: function (newVal) {
                var oldVal = cursor;
                cursor = newVal;
                this._onCursorChanged(newVal, oldVal);
            }
        });
    }

    InteractionMode.prototype = {

        /**
         * @param {MouseEvent} mouseEvent - The JS MouseEvent object
         * @param {PDFedit.document.Page} page - The page that the mousedown event occurred on.
         */
        onMouseDown: function (mouseEvent, page) {
        },

        /**
         * @param {MouseEvent} mouseEvent - The JS MouseEvent object
         * @param {PDFedit.document.Page} page - The page for processing mouseup event on.
         *   This isn't necessarily the page that the mouse was over when the event occurred.
         */
        onMouseUp: function (mouseEvent, page) {
        },

        /**
         * @param {MouseEvent} mouseEvent - The JS MouseEvent object
         * @param {PDFedit.document.Page} page - The page that the click event occurred on.
         */
        onMouseClick: function (mouseEvent, page) {
        },

        /**
         * @param {MouseEvent} mouseEvent - The JS MouseEvent object
         * @param {PDFedit.document.Page} page - The page that the mousemove event occurred on.
         */
        onMouseMove: function (mouseEvent, page) {
        },

        /**
         * @param {PDFedit.document.Page} page - The page that the mousedown event occurred on.
         */
        renderToCanvas: function (page) {
        },

        addPdfElement: function (callback) {
            if (typeof callback === 'function') {
                this._addPdfElementCallbacks.push(callback);
            }
        },
        onAddPdfElement: function (pdfElement) {
            this._addPdfElementCallbacks.forEach(function (callback) {
                callback(pdfElement);
            });
        },

        cursorChanged: function (callback) {
            if (typeof callback === 'function') {
                this._cursorChangedCallbacks.push(callback);
            }
        },
        _onCursorChanged: function (cursorNew, cursorOld) {
            this._cursorChangedCallbacks.forEach(function (callback) {
                callback(cursorNew, cursorOld);
            });
        }
    };

    return InteractionMode;
})();

module.exports = InteractionMode;